export const BASE_URL
  = 'https://mate-academy.github.io/react_phone-catalog/_new/';

export const GITHUB_URL
= 'https://github.com/NasyTheSlayer';

export const SORT_BY = {
  Newest: 'age',
  Alphabetically: 'name',
  Cheapest: 'price',
};

export const ITEMS_PER_PAGE = {
  4: '4',
  8: '8',
  16: '16',
  All: 'all',
};

export const PRODUCTS_COLORS: { [color:string]: string } = {
  black: '#4C4C4C',
  rosegold: '#FED0C6',
  gold: '#FCDBC1',
  silver: '#F0F0EE',
  spacegray: '#8D8D92',
  green: '#A3EACC',
  yellow: '#FEE870',
  white: '#F0F0F0',
  purple: '#EDE1F9',
  red: '#C91C38',
  coral: '#FF7F50',
  midnightgreen: '#5F7170',
};

export const CARDS_PER_PAGE_DESKTOP = 4;
export const CARDS_PER_PAGE_TABLET = 3;
export const CARDS_PER_PAGE_MOBILE = 2;

export const MIN_WIDTH_DESKTOP = 1200;
export const MIN_WIDTH_TABLET = 992;
export const MIN_WIDTH_MOBILE = 767;
